// src/App.js
import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { isLoggedIn } from './utils/general'
import SideMenu from 'components/SideMenu/SideMenu'

import NoMatch from './pages/NoMatch'
import Login from './pages/login/Login'
import { Dashboard } from './pages/Dashboard'
import { Administradores, Usuarios } from './pages/Usuarios'
import Categorias from './pages/categorias/Categorias'
import Productos from './pages/productos/Productos'
import { Inicio, AcercaDe, Contacto } from './pages/modificaciones'
import { TestComponent } from 'pages/test'
import Noticias from 'pages/noticias/Noticias'
import Pedidos, { PedidosHistorial } from 'pages/pedidos'
import Faq from 'pages/faq'
import TerminosCondiciones from 'pages/terminos/TerminosCondiciones'
import Atributos from 'pages/atributos'
import Reportes from 'pages/reportes'

function App() {
	// login state
	const [loggedIn, setLoggedIn] = useState(
		isLoggedIn()
	);

	const [menuExpanded, setMenuExpanded] = useState(true)

	if (menuExpanded) {
		document.body.classList.add('menu-expanded')
	} else {
		document.body.classList.remove('menu-expanded')
	}

	useEffect(() => {
		setLoggedIn(isLoggedIn())
	}, []);

	// render
	return (
		<>
			<ToastContainer />
			<Router basename={process.env.PUBLIC_URL}>
				<Route render={({ location, history }) => (
					<>
						<Route exact path="/login" component={props => <Login setLoggedIn={(setLoggedIn)} history={history} />} />
						{loggedIn && <SideMenu location={location} history={history} setLoggedIn={setLoggedIn} menuExpanded={menuExpanded} setMenuExpanded={setMenuExpanded} />}
						<main className={menuExpanded ? 'section expanded' : 'section'}>
							<Switch>
								<Route exact path="/" render={() => {
									return (
										<Redirect to="/inicio" />
									)
								}} />
								<Route exact path="/inicio">
									<Dashboard />
								</Route>
								<Route exact path="/usuarios/administradores">
									<Administradores />
								</Route>
								<Route exact path="/usuarios/clientes">
									<Usuarios />
								</Route>
								<Route exact path="/atributos">
									<Atributos />
								</Route>
								<Route exact path="/categorias">
									<Categorias />
								</Route>
								<Route exact path="/productos">
									<Productos />
								</Route>
								<Route exact path="/pedidos">
									<Pedidos />
								</Route>
								<Route exact path="/pedidos-historial">
									<PedidosHistorial />
								</Route>
								<Route path="/reportes">
									<Reportes />
								</Route>
								<Route exact path="/modificaciones/inicio">
									<Inicio />
								</Route>
								<Route exact path="/modificaciones/acerca-de">
									<AcercaDe />
								</Route>
								<Route exact path="/modificaciones/Contacto">
									<Contacto />
								</Route>
								<Route exact path="/noticias">
									<Noticias />
								</Route>
								<Route exact path="/faq">
									<Faq />
								</Route>
								<Route exact path="/terminos">
									<TerminosCondiciones />
								</Route>
								<Route exact path="/test">
									<TestComponent />
								</Route>
								{loggedIn && <Route path="*" component={props => <NoMatch />} />}
							</Switch>
						</main>
					</>
				)}
				/>
				{!loggedIn && <Redirect to="/login" />}
			</Router>
		</>
	);
}

export default App
